<template>
	<section :style="styles">
		<div class="timeline-box">
			<div v-for="(rowlog, index) of data.situacaoLog" :key="index" class="timeline-row-item">
				<span class="box-situation-info">
					<span class="text-situation">
						<div class="situation-box-widget">
							<i
								class="icon-bg"
								:class="
									index === data.situacaoLog.length - 1
										? `animate-${removeAcento(data.situacaoDesc[rowlog.situacao_id].toLowerCase())}`
										: null
								"
								:style="`background-color:${returnIconProperties(rowlog.situacao_id).color}31;`"
							>
								<feather
									:type="returnIconProperties(rowlog.situacao_id).type"
									size="15"
									:style="`color: ${returnIconProperties(rowlog.situacao_id).color}`"
								/>
							</i>
							<div style="display: flex; flex-direction: column">
								<span class="title-desc-sit">
									{{ data.situacaoDesc[rowlog.situacao_id] }}
								</span>
								<span v-if="rowlog.observacao" class="title-desc-sit" style="font-weight: 500">
									{{ rowlog.observacao }}
								</span>
							</div>
						</div>
					</span>

					<span class="text-situation">
						<!-- <k-tag
							:title="returnElapsedTime(rowlog.created_at)"
							padding="2px 12px 2px 12px"
							color="#e91e63"
							font-size="9px"
							font-weight="600"
						/> -->

						<span>{{ dateTimeToBrasil(rowlog.created_at) }}</span>
						<span style="font-weight: 500">{{ rowlog.created_by }}</span>
					</span>
				</span>
			</div>
		</div>
	</section>
</template>

<script>
/* eslint-disable no-param-reassign */
import 'moment/locale/pt-br';
import global from '../../../mixins/global';
// import kTag from '../tags/k-tag-simple';

export default {
	components: {
		// kTag,
	},
	mixins: [global],
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		icon: {
			type: Object,
			default: () => ({
				type: 'filter',
				size: '14px',
				color: '#000000',
			}),
		},
		title: {
			type: String,
			default: 'Filtros',
		},
		fontSize: {
			type: String,
			default: '12px',
		},
		backgroundColor: {
			type: String,
			default: '#FFF',
		},
		marginLeft: {
			type: String,
			default: '0px',
		},
		marginRight: {
			type: String,
			default: '0px',
		},
		borderRadius: {
			type: String,
			default: '0',
		},
		width: {
			type: String,
			default: '100%',
		},
		height: {
			type: String,
			default: '',
		},
		borderWidth: {
			type: String,
			default: '0',
		},
		borderStyle: {
			type: String,
			default: 'none',
		},
		borderColor: {
			type: String,
			default: 'none',
		},
		letterSpacing: {
			type: String,
			default: '0',
		},
		display: {
			type: String,
			default: 'flex',
		},
		alignItems: {
			type: String,
			default: 'center',
		},
		justifyContent: {
			type: String,
			default: 'center',
		},
		fontFamily: {
			type: String,
			default: 'Sora, sans-serif !important',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		},
		minHeight: {
			type: String,
			default: 'bold',
		},
	},
	data() {
		return {
			icon_color: '#7159c1',
			newDescSituation: {},
			options: {
				0: {
					id: 0,
					label: 'Recebido',
					type: 'check',
					color: '#7159c1',
				},
				1: {
					id: 1,
					label: 'Aprovado',
					type: 'check-circle',
					color: '#ffb703',
				},
				2: {
					id: 2,
					label: 'Integrado',
					type: 'settings',
					color: '#7159c1',
				},
				3: {
					id: 3,
					label: 'Inválido',
					type: 'alert-triangle',
					color: '#7159c1',
				},
				4: {
					id: 4,
					label: 'Concluído',
					type: 'flag',
					color: '#4caf50',
				},
				'-2': {
					id: -2,
					label: 'Análise',
					type: 'clock',
					color: '#808080',
				},
				'-1': {
					id: -1,
					label: 'Digitando',
					type: 'edit-3',
					color: '#7159c1',
				},
			},
		};
	},
	computed: {
		styles() {
			return {
				fontSize: this.fontSize,
				backgroundColor: this.backgroundColor,
				borderRadius: this.borderRadius,
				width: this.width,
				height: this.height,
				borderWidth: this.borderWidth,
				borderStyle: this.borderStyle,
				borderColor: this.borderColor,
				display: this.display,
				alignItems: this.alignItems,
				fontFamily: this.fontFamily,
				fontWeight: this.fontWeight,
				justifyContent: this.justifyContent,
				letterSpacing: this.letterSpacing,
				marginLeft: this.marginLeft,
				marginRight: this.marginRight,
				minHeight: this.minHeight,
			};
		},
	},

	methods: {
		removeAcento(text) {
			text = text.toLowerCase();
			text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
			text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
			text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
			text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
			text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
			text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
			return text;
		},
		returnIconProperties(params) {
			if (params) {
				return this.options[params];
			}
			return { type: 'archive' };
		},
	},
};
</script>

<style scoped lang="scss">
@import './keyframes.animations.css';

.datetimebrasil {
	font-size: 10px;
	font-weight: bold;
	margin-top: 5px;
}
.situation-box-widget {
	display: flex;
	align-items: center;
}
.timeline-row-item {
	background-color: rgb(255, 255, 255);
	width: 100%;
	margin-bottom: 30px;
	display: flex;
	justify-content: space-between;
}
.timeline-box {
	width: 100%;
}
.box-situation-info {
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.title-desc-sit {
	margin-left: 10px;
}
.text-situation {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
}
.icon-bg {
	display: flex;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	align-items: center;
	justify-content: center;
}
.animate {
	animation: pulse 2s infinite;
}

$situations: 'recebido', 'aprovado', 'integrado', 'Invalido', 'concluido', 'analise', 'digitando';

@each $situation in $situations {
	.animate-#{$situation} {
		animation: pulse-#{$situation} 2s infinite;
	}
}
</style>

